import React from "react";

import Header from "../Header/Header";

const LoadingEvent = ({ message }) => {
  return (
    <div className="event-dashboard-page">
      <Header />
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingEvent;
